<div class="code-block-wrapper">
  @if (copyable) {
    <hyperkit-icon
      class="copy-btn"
      icon="copy"
      size="base"
      (click)="copied.emit(code)"
    ></hyperkit-icon>
  }
  <pre class="code-block"><code>{{ code }}</code></pre>
</div>
